module.exports = __webpack_public_path__ + "img/navbg.200d42b9.png";